<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 107 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M107 53.5C107 83.0472 83.0472 107 53.5 107C23.9528 107 0 83.0472 0 53.5C0 23.9528 23.9528 0 53.5 0C83.0472 0 107 23.9528 107 53.5ZM49 19C49 16.7909 50.7909 15 53 15H54C56.2091 15 58 16.7909 58 19V63C58 65.2091 56.2091 67 54 67H53C50.7909 67 49 65.2091 49 63V19ZM53 83C50.7909 83 49 84.7909 49 87V88C49 90.2091 50.7909 92 53 92H54C56.2091 92 58 90.2091 58 88V87C58 84.7909 56.2091 83 54 83H53Z"
      fill="currentColor"
    />
  </svg>
</template>
